var map = {
	"./badminton.png": 158,
	"./basketbal.png": 159,
	"./fiets2.0.png": 160,
	"./gamecontroller.png": 161,
	"./laptop.png": 162,
	"./smartboard.png": 163,
	"./sportschoen.png": 164,
	"./tv.png": 165,
	"./voetbal.png": 166,
	"./waterkoker.png": 167
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 157;